function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as s } from "./index.es33.js";
import { clsx as o } from "./index.es105.js";
import { Typography as f } from "./index.es35.js";
import { palette as p } from "./index.es36.js";
import { Icon as c } from "./index.es7.js";
import { checkboxSelectors as t } from "./index.es141.js";
import e from "./index.es142.js";

var z = function z(_ref) {
  var _o2;

  var n = _ref.children,
      m = _ref.name,
      r = _ref.onChange,
      d = _ref.isValue,
      _ref$isDisabled = _ref.isDisabled,
      h = _ref$isDisabled === void 0 ? !1 : _ref$isDisabled,
      a = _ref.isIndeterminate,
      i = _ref.isSkipFocus,
      _ref$isExpandedClickA = _ref.isExpandedClickArea,
      x = _ref$isExpandedClickA === void 0 ? !1 : _ref$isExpandedClickA,
      b = _ref.kind,
      k = _ref.isOnTop;

  var y = function y(l) {
    r && r(l.target.checked);
  };

  return s.jsxs("label", {
    className: o(t.classNames.labelWrapper, e.wrapper),
    onClick: function onClick(l) {
      return l.stopPropagation();
    },
    children: [s.jsx("input", {
      className: o(e.input, _defineProperty({}, e.inputSkipFocus, i)),
      type: "checkbox",
      checked: !!(d || a),
      tabIndex: i ? -1 : void 0,
      id: m,
      onChange: y,
      disabled: h
    }), s.jsxs(f.Body2, {
      as: "div",
      className: o(t.classNames.label, e.label, (_o2 = {}, _defineProperty(_o2, e.pinchToTop, k), _defineProperty(_o2, e.labelExpandedClickArea, x), _defineProperty(_o2, e.roundedLabel, b === "circle"), _o2)),
      children: [s.jsx(c, {
        icon: c.icons.system.xs.glyphs.dash,
        color: p.gray1,
        size: 12,
        className: o("checkboxIcon", _defineProperty({}, e.hidden, !a)),
        as: "i"
      }, "indeterminated"), s.jsx(c, {
        className: o("checkboxIcon", _defineProperty({}, e.hidden, a)),
        icon: c.icons.system.xs.glyphs.tick,
        color: p.gray1,
        size: 12,
        as: "i"
      }, "check"), n]
    })]
  });
};

export { z as Checkbox };